'use client';

import * as React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { enGB } from 'date-fns/locale';

import { Button } from '../ui/button';
import { Calendar } from '../ui/calendar';
import { Label } from '../ui/label';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

interface DatePickerInputProps {
  label: string;
  date: Date | undefined;
  setDate: (date: Date | undefined) => void;
}

function DatePickerInput({ label, date, setDate }: DatePickerInputProps) {
  const [open, setOpen] = React.useState(false);
  const triggerRef = React.useRef<HTMLButtonElement>(null);

  return (
    <div className='flex flex-col gap-3 w-full'>
      <Label htmlFor='date' className='px-1'>
        {label}
      </Label>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            ref={triggerRef}
            variant='outline'
            id='date'
            className='w-full justify-between font-normal'
          >
            {date ? date.toLocaleDateString() : 'Select date'}
            <ChevronDownIcon />
          </Button>
        </PopoverTrigger>
        <PopoverContent
          className='overflow-hidden p-0'
          align='start'
          style={{ width: 300 }}
        >
          <Calendar
            mode='single'
            selected={date}
            captionLayout='dropdown'
            onSelect={(selectedDate) => {
              setDate(selectedDate);
              setOpen(false);
            }}
            className='w-full'
            locale={enGB}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}

export default DatePickerInput;
